import styled from 'styled-components';

export const SupportWrapper = styled.div`
.support-row .bg-light {
    border-radius: 5px;
    border: solid 1px #d6d7d8;
    background-image: #fff;
    margin-bottom: 30px;
}

.support-row .bg-light .content-wrapper {
    padding: 36px 33px 0 33px;
}

.gradient-bg-blue {
    background: rgba(255, 255, 255, 1);
    background: -moz-linear-gradient(top, rgba(255, 255, 255, 1) 0%, rgba(246, 246, 246, 1) 47%, rgba(221, 230, 255, 1) 100%);
    background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(255, 255, 255, 1)), color-stop(47%, rgba(246, 246, 246, 1)), color-stop(100%, rgba(221, 230, 255, 1)));
    background: -webkit-linear-gradient(top, rgba(255, 255, 255, 1) 0%, rgba(246, 246, 246, 1) 47%, rgba(221, 230, 255, 1) 100%);
    background: -o-linear-gradient(top, rgba(255, 255, 255, 1) 0%, rgba(246, 246, 246, 1) 47%, rgba(221, 230, 255, 1) 100%);
    background: -ms-linear-gradient(top, rgba(255, 255, 255, 1) 0%, rgba(246, 246, 246, 1) 47%, rgba(221, 230, 255, 1) 100%);
    background: linear-gradient(to bottom, rgba(255, 255, 255, 1) 0%, rgba(246, 246, 246, 1) 47%, rgba(221, 230, 255, 1) 100%);
    filter: progid: DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#dde6ff', GradientType=0);
}

.gradient-bg-lightblue {
    background: rgba(255, 255, 255, 1);
    background: -moz-linear-gradient(top, rgba(255, 255, 255, 1) 0%, rgba(246, 246, 246, 1) 47%, rgba(229, 249, 254, 1) 100%);
    background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(255, 255, 255, 1)), color-stop(47%, rgba(246, 246, 246, 1)), color-stop(100%, rgba(229, 249, 254, 1)));
    background: -webkit-linear-gradient(top, rgba(255, 255, 255, 1) 0%, rgba(246, 246, 246, 1) 47%, rgba(229, 249, 254, 1) 100%);
    background: -o-linear-gradient(top, rgba(255, 255, 255, 1) 0%, rgba(246, 246, 246, 1) 47%, rgba(229, 249, 254, 1) 100%);
    background: -ms-linear-gradient(top, rgba(255, 255, 255, 1) 0%, rgba(246, 246, 246, 1) 47%, rgba(229, 249, 254, 1) 100%);
    background: linear-gradient(to bottom, rgba(255, 255, 255, 1) 0%, rgba(246, 246, 246, 1) 47%, rgba(229, 249, 254, 1) 100%);
    filter: progid: DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#e5f9fe', GradientType=0);
}

.gradient-bg-orange {
    background: rgba(255, 255, 255, 1);
    background: -moz-linear-gradient(top, rgba(255, 255, 255, 1) 0%, rgba(246, 246, 246, 1) 47%, rgba(255, 246, 220, 1) 100%);
    background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(255, 255, 255, 1)), color-stop(47%, rgba(246, 246, 246, 1)), color-stop(100%, rgba(255, 246, 220, 1)));
    background: -webkit-linear-gradient(top, rgba(255, 255, 255, 1) 0%, rgba(246, 246, 246, 1) 47%, rgba(255, 246, 220, 1) 100%);
    background: -o-linear-gradient(top, rgba(255, 255, 255, 1) 0%, rgba(246, 246, 246, 1) 47%, rgba(255, 246, 220, 1) 100%);
    background: -ms-linear-gradient(top, rgba(255, 255, 255, 1) 0%, rgba(246, 246, 246, 1) 47%, rgba(255, 246, 220, 1) 100%);
    background: linear-gradient(to bottom, rgba(255, 255, 255, 1) 0%, rgba(246, 246, 246, 1) 47%, rgba(255, 246, 220, 1) 100%);
    filter: progid: DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#fff6dc', GradientType=0);
}

.gradient-bg-green {
    background: rgba(255, 255, 255, 1);
    background: -moz-linear-gradient(top, rgba(255, 255, 255, 1) 0%, rgba(246, 246, 246, 1) 47%, rgba(220, 237, 226, 1) 100%);
    background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(255, 255, 255, 1)), color-stop(47%, rgba(246, 246, 246, 1)), color-stop(100%, rgba(220, 237, 226, 1)));
    background: -webkit-linear-gradient(top, rgba(255, 255, 255, 1) 0%, rgba(246, 246, 246, 1) 47%, rgba(220, 237, 226, 1) 100%);
    background: -o-linear-gradient(top, rgba(255, 255, 255, 1) 0%, rgba(246, 246, 246, 1) 47%, rgba(220, 237, 226, 1) 100%);
    background: -ms-linear-gradient(top, rgba(255, 255, 255, 1) 0%, rgba(246, 246, 246, 1) 47%, rgba(220, 237, 226, 1) 100%);
    background: linear-gradient(to bottom, rgba(255, 255, 255, 1) 0%, rgba(246, 246, 246, 1) 47%, rgba(220, 237, 226, 1) 100%);
    filter: progid: DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#dcede2', GradientType=0);
}

.gradient-bg-red {
    background: rgba(255, 255, 255, 1);
    background: -moz-linear-gradient(top, rgba(255, 255, 255, 1) 0%, rgba(246, 246, 246, 1) 47%, rgba(249, 219, 218, 1) 100%);
    background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(255, 255, 255, 1)), color-stop(47%, rgba(246, 246, 246, 1)), color-stop(100%, rgba(249, 219, 218, 1)));
    background: -webkit-linear-gradient(top, rgba(255, 255, 255, 1) 0%, rgba(246, 246, 246, 1) 47%, rgba(249, 219, 218, 1) 100%);
    background: -o-linear-gradient(top, rgba(255, 255, 255, 1) 0%, rgba(246, 246, 246, 1) 47%, rgba(249, 219, 218, 1) 100%);
    background: -ms-linear-gradient(top, rgba(255, 255, 255, 1) 0%, rgba(246, 246, 246, 1) 47%, rgba(249, 219, 218, 1) 100%);
    background: linear-gradient(to bottom, rgba(255, 255, 255, 1) 0%, rgba(246, 246, 246, 1) 47%, rgba(249, 219, 218, 1) 100%);
    filter: progid: DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#f9dbda', GradientType=0);
}

.gradient-bg-skyblue {
    background: rgba(255, 255, 255, 1);
    background: -moz-linear-gradient(top, rgba(255, 255, 255, 1) 0%, rgba(246, 246, 246, 1) 47%, rgba(224, 232, 254, 1) 100%);
    background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(255, 255, 255, 1)), color-stop(47%, rgba(246, 246, 246, 1)), color-stop(100%, rgba(224, 232, 254, 1)));
    background: -webkit-linear-gradient(top, rgba(255, 255, 255, 1) 0%, rgba(246, 246, 246, 1) 47%, rgba(224, 232, 254, 1) 100%);
    background: -o-linear-gradient(top, rgba(255, 255, 255, 1) 0%, rgba(246, 246, 246, 1) 47%, rgba(224, 232, 254, 1) 100%);
    background: -ms-linear-gradient(top, rgba(255, 255, 255, 1) 0%, rgba(246, 246, 246, 1) 47%, rgba(224, 232, 254, 1) 100%);
    background: linear-gradient(to bottom, rgba(255, 255, 255, 1) 0%, rgba(246, 246, 246, 1) 47%, rgba(224, 232, 254, 1) 100%);
    filter: progid: DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#e0e8fe', GradientType=0);
}

.headtitle h1 {
    font-size: 48px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: -0.43px;
    color: #333333;
}

.btn-support {
    width: 96px;
    height: 22px;
    border-radius: 10px;
    background-color: #4db4cc;
    font-size: 10px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 10px;
    letter-spacing: normal;
    text-align: center;
    color: #fff;
}

.support-content-row img {
    outline: 2px solid #dcdce0;
    outline-offset: -2px;
    width: 100%;
    margin-bottom: 30px;
}

.support-info h2 {
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 25px;
}

.support-info p {
    font-size: 12px;
    font-weight: 400;
    color: #333333;
    line-height: 1.5;
    letter-spacing: normal;
    margin-bottom: 0;
}

.support-info a {
    font-size: 12px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 3;
    color: #093ac8;
    text-decoration: none;
}

.support-info a i {
    font-size: 12px;
    color: #333333;
}

.support-info {
    padding-right: 80px;
    margin-bottom: 35px;
}

.btn-tutorial {
    height: 47px;
    width: 100%;
    -webkit-border-bottom-right-radius: 5px;
    -webkit-border-bottom-left-radius: 5px;
    -moz-border-radius-bottomright: 5px;
    -moz-border-radius-bottomleft: 5px;
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
    background-color: #7e98e4;
    font-size: 16px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 48px;
    text-align: center;
    color: #fff !important;
    display: block;
    text-decoration: none!important;
    transition: 0.5s;
}

.btn-tutorial:hover {
    opacity: .8;
    color: #fff !important;
    text-decoration: none!important;
}

.gradient-bg-lightblue .btn-tutorial {
    background-color: #c2e5ee;
    color: #333333!important;
}

.gradient-bg-orange .btn-tutorial {
    background-color: #f2db95;
    color: #333333!important;
}

.gradient-bg-green .btn-tutorial {
    background-color: #a1d0b1;
    color: #333333!important;
}

.gradient-bg-red .btn-tutorial {
    background-color: #e6a4a3;
    color: #333333!important;
}

.gradient-bg-skyblue .btn-tutorial {
    background-color: #a8b8e4;
    color: #333333!important;
}

button:focus,
textarea:focus,
input:focus {
    outline: none!important;
    box-shadow: none !important;
}


@media (max-width: 1200px) {
    .support-info {
        padding-right: 0;
    }
}

@media (max-width: 992px) {
    .support-content-row img {
        margin-bottom: 30px;
    }
    .headtitle h1 {
        font-size: 30px;
    }
}

`